import { render } from "./RewardsComponent.vue?vue&type=template&id=5fc1c83a&scoped=true"
import script from "./RewardsComponent.vue?vue&type=script&lang=js"
export * from "./RewardsComponent.vue?vue&type=script&lang=js"

import "./RewardsComponent.vue?vue&type=style&index=0&id=5fc1c83a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc1c83a"]])

export default __exports__